(() => {
  const desktop = matchMedia('(min-width: 700px)');
  const start = () => {
  const layouts = [
    ['.ss-furniture-grid', ':scope > .ss-furniture-card', ['.ss-furniture-media', '.prose > h3', '.prose > p', '.prose > .button']],
    ['.ss-line-grid', ':scope > .ss-line-card', ['img', 'h3', 'p', '.link']],
    ['.ss-reference-grid', ':scope > .ss-reference', ['.ss-reference__media', '.ss-project-media-note', '.prose > h3', '.prose > p', '.ss-reference__configuration']],
    ['.multi-column', ':scope > .multi-column__item:not(.multi-column__item--overlap)', ['.multi-column__media', '.ss-column-heading', '.ss-column-body', '.ss-column-action']],
    ['.ss-pdp-facts', ':scope > div', ['dt', 'dd']],
    ['.ss-pdp-planning', ':scope > .prose', ['h3', 'p', '.link']],
    ['.ss-about__grid', ':scope > .ss-about__value', ['span', 'h3', 'p']],
    ['.ss-about__media-grid', ':scope > article', ['img', 'h3']],
    ['.ss-config__grid', ':scope > .ss-config__card', ['.ss-config__placeholder', '.prose > h3', '.prose > p']],
    ['.ss-showroom__info-grid', ':scope > .prose', ['h3', 'p']],
    ['.product-list:not(.product-list--compact), .ss-pdp-cards', ':scope > .product-card', ['.product-card__figure', '.product-title', 'price-list']]
  ];

  const selector = layouts.map(([selector]) => selector).join(',');
  const containers = new Map();
  const dirty = new Set();
  const visible = new Set();
  const visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { visible.add(entry.target); schedule(entry.target); }
      else visible.delete(entry.target);
    });
  }, {rootMargin: "0px"});
  const widths = new WeakMap();
  const contentObservers = new WeakMap();
  let frame = 0;
  function schedule(container) {
    if (container && containers.has(container) && visible.has(container)) dirty.add(container);
    if (dirty.size && !frame) frame = requestAnimationFrame(align);
  }
  const resize = new ResizeObserver(entries => {
    entries.forEach(({target, contentRect}) => {
      const old = widths.get(target);
      widths.set(target, contentRect.width);
      if (old === undefined || Math.abs(old - contentRect.width) > .5) schedule(target);
    });
  });
  function discover(root) {
    const found = [];
    if (root instanceof Element && root.matches(selector)) found.push(root);
    if (root.querySelectorAll) found.push(...root.querySelectorAll(selector));
    found.forEach(container => {
      if (containers.has(container)) return;
      const layout = layouts.find(([match]) => container.matches(match));
      containers.set(container, layout);
      resize.observe(container);
      visibility.observe(container);
      const changes = new MutationObserver(records => {
        if (records.some(record => {
          if (record.type === 'attributes') return record.target.matches('product-card');
          if (record.target === container) return true;
          return record.target.nodeType === 1 && record.target.closest('.product-title, price-list');
        })) schedule(container);
      });
      changes.observe(container, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']});
      contentObservers.set(container, changes);
    });
  }
  function align() {
    frame = 0;
    const batch = [...dirty].filter(container => container.isConnected);
    dirty.clear();
    batch.forEach(container => container.querySelectorAll('[data-ss-row-height]').forEach(part => {
      part.removeAttribute('data-ss-row-height');
      part.style.removeProperty('--ss-row-height');
    }));
    if (matchMedia('(max-width: 699px)').matches) return;
    const updates = [];
    batch.forEach(container => {
      const [, cardSelector, parts] = containers.get(container);
      const rows = [];
      container.querySelectorAll(cardSelector).forEach(card => {
        const rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        let row = rows.find(row => Math.abs(row.top - rect.top) < 3);
        if (!row) rows.push(row = {top: rect.top, cards: []});
        row.cards.push(card);
      });
      rows.filter(row => row.cards.length > 1).forEach(row => parts.forEach(partSelector => {
        const peers = row.cards.map(card => card.querySelector(partSelector)).filter(Boolean);
        if (peers.length < 2) return;
        const height = Math.ceil(Math.max(...peers.map(part => part.getBoundingClientRect().height)));
        if (height) peers.forEach(part => updates.push([part, height]));
      }));
    });
    updates.forEach(([part, height]) => {
      part.style.setProperty('--ss-row-height', height + 'px');
      part.setAttribute('data-ss-row-height', '');
    });
    containers.forEach((_, container) => {
      if (!container.isConnected) { resize.unobserve(container); visibility.unobserve(container); contentObservers.get(container)?.disconnect(); visible.delete(container); containers.delete(container); }
    });
  }
  window.addEventListener('resize', () => containers.forEach((_, container) => schedule(container)), {passive: true});
  document.addEventListener('shopify:section:load', event => discover(event.target));
  document.querySelectorAll('.shopify-section').forEach(section => {
    new MutationObserver(() => discover(section)).observe(section, {childList: true});
  });
  document.fonts?.ready.then(() => containers.forEach((_, container) => schedule(container)));
  discover(document);
  };
  if (desktop.matches) start();
  else {
    const enable = event => {
      if (!event.matches) return;
      desktop.removeEventListener('change', enable);
      start();
    };
    desktop.addEventListener('change', enable);
  }
})();

